import React from "react";
import { useGetProjectsQuery } from "../../../features/projects/projectsApi";
import Project from "./Project";

const Projects = () => {

  const { isError, isLoading, data } = useGetProjectsQuery();

  // decide what to render based on the state of the query
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>Something went wrong</div>;
  }
  if (!isLoading && !isError && data.length > 0) {
    content = data.map((project) => <Project key={project.id} {...project} />);
  }
  

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default Projects;
